export default __webpack_public_path__ + "static/media/ios.9e34caae.png";